export const WeightOptions = {
  GRAMS: 'g',
  OUNCES: 'oz'
}

export const AmountOptions = {
  WEIGHT: 'weight',
  PERCENT: 'percent'
}
